export const PARTICIPATION_RETIRED_CODE='PARTICIPATION_CONTRACT_RETIRED';
export const PARTICIPATION_RETIRED_MESSAGE='This route is retired. This request was not converted or applied. Use the governed participation workflow; earlier request outcomes are not established.';
